import {fabric} from 'fabric';
import {uuid} from '../../utils';
import {message} from 'antd';

export const loadImageDom = async (url: string) => {
    return new Promise((resolve, reject) => {
        fabric.util.loadImage(
            url,
            (img) => {
                if (img) {
                    return resolve(img);
                }
                message.error('Failed to load image');
                return reject();
            },
            null,
            'anonymous',
        );
    });
};

export const loadImage = async (imageSource: any) => {
    if (typeof imageSource === 'string') {
        return new Promise<fabric.Image>((resolve, reject) => {
            fabric.Image.fromURL(
                imageSource,
                (img) => {
                    if (!img) {
                        message.error('Failed to load image');
                        reject();
                        return;
                    }
                    resolve(img);
                },
                {
                    crossOrigin: 'anonymous',
                },
            );
        });
    }
    return Promise.resolve(new fabric.Image(imageSource));
};

export const createClipRect = (object: {getScaledWidth: () => any; getScaledHeight: () => any}, options = {}) => {
    const width = object.getScaledWidth();
    const height = object.getScaledHeight();
    return new fabric.Rect({
        left: -width / 2,
        top: -height / 2,
        width,
        height,
        ...options,
    });
};

const scaleImageToFitCanvas = (img: fabric.Image, canvas: fabric.Canvas, sketch: any) => {
    /*    const canvasWidth = canvas.getWidth();
    const canvasHeight = canvas.getHeight();   */
    const canvasWidth = sketch.width;
    const canvasHeight = sketch.height;
    const imgWidth = img.width!;
    const imgHeight = img.height!;

    const widthRatio = canvasWidth / imgWidth;
    const heightRatio = canvasHeight / imgHeight;
    const scaleRatio = Math.min(widthRatio, heightRatio);

    if (scaleRatio < 1) {
        img.scale(scaleRatio);
    }
};

export const createImage = async (options: any) => {
    const {imageSource, canvas, sketch, ...rest} = options || {};

    let img!: fabric.Image;
    try {
        img = await loadImage(imageSource);
    } catch (e) {
        console.log(e);
    }

    if (!img) return;

    // Scale the image to fit within the canvas
    scaleImageToFitCanvas(img, canvas, sketch);

    img.set({
        ...rest,
        paintFirst: 'fill',
        id: uuid(),
    });

    canvas.viewportCenterObject(img);
    canvas.add(img);
    canvas.setActiveObject(img);
    canvas.requestRenderAll();

    return img;
};

export const createFImage = async (options: any) => {
    const {imageSource, canvas, sketch, ...rest} = options || {};
    const originalImageUrl = options.originalImageUrl;

    let img!: fabric.Image;
    try {
        img = await loadImage(imageSource);
    } catch (e) {
        console.log(e);
    }

    if (!img) return;
    // Scale the image to fit within the canvas
    if (sketch) {
        scaleImageToFitCanvas(img, canvas, sketch);
    }

    // @ts-ignore
    const fimg = new fabric.FImage({
        image: img,
        id: uuid(),
        originalImageUrl: originalImageUrl ? originalImageUrl : '',
    });

    // @ts-ignore
    let imageTextureSize = img.width > img.height ? img.width : img.height;

    if (imageTextureSize && imageTextureSize > fabric.textureSize) {
        fabric.textureSize = imageTextureSize;
    }
    canvas.viewportCenterObject(fimg);
    canvas.add(fimg);
    canvas.setActiveObject(fimg);
    canvas.requestRenderAll();
};

export const addSvg = async (svgContent: string | ArrayBuffer | null, canvas: any) => {
    if (canvas && svgContent) {
        fabric.loadSVGFromString(
            svgContent as string,
            (objects, options) => {
                const svg = fabric.util.groupSVGElements(objects, options);
                canvas.add(svg);
                canvas.centerObject(svg);
                canvas.setActiveObject(svg);
                canvas.requestRenderAll();
            },
            (error: any) => {
                console.error('Failed to load SVG', error);
            },
        );
    }
};
